import React from 'react';
import UserForm from './UserForm';

const CreateUser = ({ handleCloseAddModal, onCreateSuccess }) => {
  return (
    <UserForm
      mode="create"
      handleCloseModal={handleCloseAddModal}
      onSuccess={onCreateSuccess}
    />
  );
};

export default CreateUser;
